import Swiper from "swiper";
import {Navigation, Pagination} from 'swiper/modules';

function useSwiperEffect(swiper) {
    swiper.el.classList.toggle('swiper-effect-before', !swiper.isBeginning);
    swiper.el.classList.toggle('swiper-effect-after', !swiper.isEnd);
}

new Swiper('.categorySwiper', {
    modules: [Navigation],
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 20,
    navigation: {
        nextEl: '.cat-swiper-next',
        prevEl: '.cat-swiper-prev',
    },
    on: {
        afterInit: useSwiperEffect,
        slideChange: useSwiperEffect,
    },
});

new Swiper('.editOptionSwiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        nextEl: '.editOption-button-next',
        prevEl: '.editOption-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        1024: {
            slidesPerView: 4,
        },
    },
    on: {
        afterInit: useSwiperEffect,
        slideChange: useSwiperEffect,
    },
});

new Swiper('.inspirationSlider', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        nextEl: '.inspiration-button-next',
        prevEl: '.inspiration-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        1024: {
            slidesPerView: 4,
        },
    },
    on: {
        afterInit: useSwiperEffect,
        slideChange: useSwiperEffect,
    },
});

new Swiper('.categoryUpSellSlider', {
    // spaceBetween: -80,
    spaceBetween: 20,
    slidesPerView: 1.25,
    freeMode: true,

    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
});

// jQuery(document).ready(function ($) {
//     $('[data-twe-collapse-init]').on('click', function() {
//         var $button = $(this);
//         var targetId = $button.data('twe-target');
//         var $targetDiv = $(targetId);
//
//         $targetDiv.toggleClass('hidden');
//
//         var isExpanded = $button.attr('aria-expanded') === 'true';
//         $button.attr('aria-expanded', !isExpanded);
//     });
//
//     // $('.video-play-button').on('click', function() {
//     //     console.log('clicked');
//     // })
// });
jQuery(function ($) {
    $(document).on('click', '[data-color]', function (e) {
        if ($(e.target).closest('[data-value]').length) return;

        const colorName = $(this).attr('data-color')?.toLowerCase();
        const $colorDiv = $(this).find('[data-value]').filter(function () {
            return $(this).attr('data-value')?.toLowerCase() === colorName;
        });

        if ($colorDiv.length) {
            $colorDiv.trigger('click');
        }
    });
})